import { render, staticRenderFns } from "./digitalAsset.vue?vue&type=template&id=08a5cc66&scoped=true&"
import script from "./digitalAsset.vue?vue&type=script&lang=js&"
export * from "./digitalAsset.vue?vue&type=script&lang=js&"
import style0 from "./digitalAsset.vue?vue&type=style&index=0&id=08a5cc66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a5cc66",
  null
  
)

export default component.exports